import { Logger } from '~~/helpers/logger';
import type { CiaDependencies } from '~/composables/useCia/types';

type NotifymeRestockRequest = {
  locale: string;
  email: string;
  productSku: string;
  user_id?: string;
  cookie?: string;
};

export default (dependencies: CiaDependencies) => {

  const { fetch, languageAndCountry } = dependencies;

  return async (
    { userId, email, productSku }: {userId: string, email: string, productSku: string}): Promise<unknown> => {

    if (import.meta.server) {

      if (import.meta.dev) {

        Logger.debug('cia|notifymeRestock SSR suppressed');
      
      }

      return Promise.resolve();
    
    }

    const payload: NotifymeRestockRequest = {
      locale: languageAndCountry,
      email,
      productSku,
    };

    if (userId) {

      payload.user_id = userId;
    
    }

    return fetch('/cia/notifyme-restock', {
      method: 'POST',
      body: payload,
    });
  
  };

};
